import { IAccount } from './company-account';

export enum AccountType {
    BillTo = 0,
    ShipTo = 1,
}

export interface IAccountBillTo extends IAccount {
    shipToAccounts: IAccount[];
}

export const getAccountDisplay = (account: IAccount) => {
    let value = '';
    if (account.partyName) {
        value = account.partyName;
    }
    if (account.fullAccountNumber) {
        if (value.length > 0) {
            value += ' ';
        }
        value += '(' + account.fullAccountNumber + ')';
    }
    if (
        account.street1 &&
        account.city &&
        account.state &&
        account.postalCode
    ) {
        if (value.length > 0) {
            value += ' - ';
        }
        value +=
            account.street1 +
            ', ' +
            account.city +
            ', ' +
            account.state +
            ' ' +
            account.postalCode;
    }
    return value;
};
